module.exports = __webpack_public_path__ + "img/ic_restore_48px@2x.48ffe72c.png";